/**
 * admin-ops-api への薄い fetch wrapper。
 *
 * Cloudflare Access の trust boundary 配下にあるため、ブラウザは自動的に
 * `Cf-Access-Jwt-Assertion` / `Cf-Access-Authenticated-User-Email` を載せる。
 * クライアント側で JWT を扱う必要はない（credentials: 'include' で cookies を運ぶだけ）。
 */
export interface HelloResponse {
  message: string;
  actor: {
    type: 'alys_owner';
    subject: string;
    email: string;
  };
}

export async function fetchHello(baseUrl: string): Promise<HelloResponse> {
  const res = await fetch(`${baseUrl.replace(/\/$/, '')}/api/v1/hello`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`admin-ops API /hello failed: ${res.status}`);
  }
  return (await res.json()) as HelloResponse;
}
